import { render } from "./PrivateList.vue?vue&type=template&id=0712dcbc&scoped=true"
import script from "./PrivateList.vue?vue&type=script&lang=js"
export * from "./PrivateList.vue?vue&type=script&lang=js"

import "./PrivateList.vue?vue&type=style&index=0&id=0712dcbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0712dcbc"]])

export default __exports__